import { combineReducers } from "redux";
import { configureStore } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist'

import storage from 'redux-persist/lib/storage'
import thunk from 'redux-thunk'

import auth from './features/auth.slice';
import options from './features/options.slice';

const reducers = combineReducers({
    auth,
    options
});

const persistConfig = {
    key: 'root',
    storage
};

const persistedReducer = persistReducer(persistConfig, reducers);
//
// const store = configureStore({
//     reducer: reducers,
//     devTools: process.env.NODE_ENV !== 'production',
//     middleware: [thunk]
// });


export const store = configureStore({
    reducer: {
        auth,
        options
    },
})

export default store;